import { Component, inject } from "@angular/core";
import { MAT_DIALOG_DATA, MatDialogRef } from "@angular/material/dialog";

export interface DragAndDropDialogData<T extends object = Record<string, unknown>>
{
    readonly groups: Array<Array<T>>;
    readonly display: keyof T;
    readonly subtitleMember: keyof T;
    readonly dialogTitle: string;
    readonly dialogSubtitle: string;
    readonly groupTitles?: Array<string>;
}

@Component({
    selector: "drag-and-drop-dialog-component",
    templateUrl: "./dragAndDropDialog.tmpl.html",
    styleUrls: [
        "./dragAndDropDialog.component.scss"
    ],
    standalone: false
})
export class DragAndDropDialogComponent<T extends object = Record<string, unknown>>
{
    private readonly dialogRef = inject<MatDialogRef<DragAndDropDialogComponent, Array<Array<T>>>>(MatDialogRef);
    private readonly data = inject<DragAndDropDialogData<T>>(MAT_DIALOG_DATA);


    get groups(): Array<Array<T>> { return this.data.groups; }
    get display(): keyof T { return this.data.display; }
    get subtitleMember(): keyof T { return this.data.subtitleMember; }
    get dialogTitle(): string { return this.data.dialogTitle; }
    get dialogSubtitle(): string { return this.data.dialogSubtitle; }
    get groupTitles(): Array<string> { return this.data.groupTitles; }

    get message(): string
    {
        const leftRightClause = this.groups.length > 1
            ? " or left and right"
            : "";
        return `Drag and drop ${this.dialogSubtitle} up and down${leftRightClause} to rearrange.`;
    }

    add(): void
    {
        // ! TODO: Whether we return this or not... the array has been changed!
        this.dialogRef.close(this.groups);
    }

    close(): void
    {
        this.dialogRef.close();
    }
}
